import { __awaiter, __rest } from "tslib";
import { cloneDeep } from 'lodash';
import { getElementsPosition, writeCanvasDataToClipboard } from '../../utils';
export class AdvancedCommand {
    constructor({ model }) {
        this.execute = (command, args) => __awaiter(this, void 0, void 0, function* () {
            return this[command](args);
        });
        this.model = model;
        this.oFlowModel = model.oFlowModel;
    }
    BATCH_ADD_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload = {} } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes = [], edges = [], groups = [] }) => {
                const { nodes: newNodes = [], edges: newEdges = [], groups: newGroups = [] } = payload;
                return {
                    nodes: [...nodes, ...newNodes],
                    edges: [...edges, ...newEdges],
                    groups: [...groups, ...newGroups],
                };
            }, res);
        });
    }
    BATCH_DELETE_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args, res = __rest(args, ["payload"]);
            return this.model.setCanvasData(({ nodes = [], edges = [], groups = [] }) => {
                return {
                    nodes: nodes.filter(node => !payload.includes(node.id)),
                    edges: edges.filter(edge => !payload.includes(edge.id) &&
                        !(payload === null || payload === void 0 ? void 0 : payload.includes(edge.target)) &&
                        !(payload === null || payload === void 0 ? void 0 : payload.includes(edge.source))),
                    groups: groups.filter(group => !payload.includes(group.id)),
                };
            }, res);
        });
    }
    BATCH_COPY_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = args.payload;
            const elements = this.model.generatePasteElementConfigByIds(payload);
            yield writeCanvasDataToClipboard(elements);
            return true;
        });
    }
    BATCH_PASTE_ELEMENTS(args) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const payload = Object.assign({ nodes: [], groups: [], edges: [] }, args.payload);
            const copyElements = cloneDeep(payload);
            const canvasInstance = this.model.canvas;
            // 鼠标在画布中, 设置粘贴节点的新位置
            if (canvasInstance.mouseInCanvas) {
                const canvasInstance = this.model.canvas;
                const { x, y } = canvasInstance.mousePosition;
                const { minLeft, minTop, maxLeft, maxTop } = getElementsPosition({
                    elements: [...copyElements.nodes, ...copyElements.groups],
                    oFlowModel: this.model.oFlowModel,
                });
                const width = maxLeft - minLeft;
                const height = maxTop - minTop;
                const [canvasLeft, canvasTop] = canvasInstance === null || canvasInstance === void 0 ? void 0 : canvasInstance.terminal2canvas([x, y]);
                const diffLeft = canvasLeft - width / 2 - minLeft;
                const diffTop = canvasTop - height / 2 - minTop;
                copyElements.nodes = copyElements.nodes.map(options => {
                    return Object.assign(Object.assign({}, options), { left: options.left + diffLeft, top: options.top + diffTop });
                });
                copyElements.groups = copyElements.groups.map(options => {
                    return Object.assign(Object.assign({}, options), { left: options.left + diffLeft, top: options.top + diffTop });
                });
            }
            else {
                copyElements.nodes = copyElements.nodes.map(options => {
                    return Object.assign(Object.assign({}, options), { left: options.left - 20, top: options.top + -20 });
                });
                copyElements.groups = copyElements.nodes.map(options => {
                    return Object.assign(Object.assign({}, options), { left: options.left - 20, top: options.top + -20 });
                });
            }
            const newIdAndOldIdMap = {};
            copyElements.edges.forEach(({ id }) => {
                newIdAndOldIdMap[id] = this.oFlowModel.generateOFlowCanvasNodeId();
            });
            copyElements.nodes.forEach(({ id }) => {
                newIdAndOldIdMap[id] = this.oFlowModel.generateOFlowCanvasNodeId();
            });
            copyElements.groups.forEach(({ id }) => {
                newIdAndOldIdMap[id] = this.oFlowModel.generateOFlowCanvasGroupId();
            });
            let jsonString = JSON.stringify(copyElements);
            (_a = Object.entries(newIdAndOldIdMap)) === null || _a === void 0 ? void 0 : _a.forEach(([originId, newId]) => {
                jsonString = jsonString === null || jsonString === void 0 ? void 0 : jsonString.replace(new RegExp(originId, 'g'), newId);
            });
            const newElements = JSON.parse(jsonString);
            return this.BATCH_ADD_ELEMENTS({ payload: newElements, traceCommand: args.traceCommand });
        });
    }
    BATCH_SELECT_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload = [] } = args;
            this.model.setSelectedElementIds(payload);
            return true;
        });
    }
    DREW_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            const { payload } = args;
            yield this.model.setCanvasData(payload);
            this.model.resetCommandhistory();
            return true;
        });
    }
    FOCUS_CENTER_ELEMENTS(args) {
        return __awaiter(this, void 0, void 0, function* () {
            this.model.canvas.focusCenterWithAnimate();
            return true;
        });
    }
}
//# sourceMappingURL=index.js.map